import React, { memo } from 'react';
import { SidebarLinks, SocialLinks } from '../../utils';
import './SideDrawer.css';

export const SideDrawer = memo((props) => {
  const { toggleSideDrawer } = props;

  return (
    <nav id='NavigationSideDrawer' className={toggleSideDrawer ? 'openNavbar' : 'closedNavbar'}>
      <ul>
        {SidebarLinks.map(({ label, url, isInternal }) => (
          <li key={label}>
            <a 
              className='flex flex-center fullsize'
              href={url}
              target={isInternal ? '_self' : '_blank'}
              rel={isInternal ? '' : 'noopener noreferrer'}
            >
              {label}
            </a>
          </li>
        ))}
        <hr style={{ border: '1px solid var(--border-strong)', width: '100%' }} />
        <div style={{display: 'flex', width: '100%', fontSize: 'var(--scale-5xl)' }} className="flex-between">
          {SocialLinks.map(({ label, url, icon, ariaLabel }) => (
            <div 
              key={url} 
              className={`cursor-pointer social-media-icon social-media-icon-${label.toLowerCase()} flex flex-center fullsize`}
            >
              <a aria-label={ariaLabel} href={url} target="_blank" rel="noopener noreferrer">
                <i className={`fa ${icon}`}></i>
              </a>
            </div>
          ))}
        </div>
      </ul>
    </nav>
  );
});
